import { Grid } from '@material-ui/core'
import React, { useState } from 'react'
import { a11yProps } from 'asterX-UI/Tabs/TabPanel'
import AsterTab from 'asterX-UI/Tabs/AsterTab'
import AsterTabs from 'asterX-UI/Tabs/AsterTabs'
import { useContractStore } from 'context/ContractStore'
import { getTabs } from './const'
import { useStyles } from './contract-tabs'

export const ContractTabs = () => {
  const classes = useStyles()
  const {
    contractStore: { contractAll }
  } = useContractStore()

  const [activeTab, setActiveTab] = useState(0)

  const tabs = getTabs(contractAll?.hadLegalStatus) || []
  const TabBody = tabs[activeTab]?.component || null

  return (
    <Grid container>
      <Grid item container className={classes.tabsContainer}>
        <AsterTabs className={classes.tabs} value={activeTab} onChange={(e, value) => setActiveTab(value)}>
          {tabs.map(({ label }, i) => (
            <AsterTab key={`tabs-${i}`} label={label} value={i} {...a11yProps(i)} />
          ))}
        </AsterTabs>
      </Grid>
      <Grid item container>
        <TabBody />
      </Grid>
    </Grid>
  )
}
